import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { BadgeCheck } from "lucide-react";

export default function Certificates() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    api.get("/certificates").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);
  return (
    <div data-testid="certificates-page" className="container-refined py-16 md:py-24">
      <div className="max-w-2xl">
        <p className="eyebrow">{t("certificates.eyebrow")}</p>
        <h1 className="mt-4 font-serif text-5xl md:text-6xl leading-[1.05] text-forest-900">{t("certificates.title")}</h1>
      </div>

      <div className="mt-14">
        {loading && <p className="text-forest-700">{t("common.loading")}</p>}
        {!loading && items.length === 0 && (
          <div className="card-warm text-center" data-testid="certificates-empty">
            <BadgeCheck className="mx-auto h-8 w-8 text-wheat-600" strokeWidth={1.25}/>
            <p className="mt-4 text-forest-700">{t("certificates.empty")}</p>
          </div>
        )}
        {!loading && items.length > 0 && (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="certificates-grid">
            {items.map((c) => {
              const comingLater = !c.file_data;
              return (
              <div key={c.id} className={`card-warm !p-6 group ${comingLater ? "border-2 border-dashed border-wheat-500/40" : ""}`} data-testid={`certificate-${c.id}`}>
                {c.file_data && (c.file_type === "image" || (c.file_data.startsWith && c.file_data.startsWith("data:image"))) ? (
                  <div className="rounded-xl overflow-hidden mb-4 border border-forest-900/10">
                    <img src={c.file_data} alt={c.title} className="w-full h-52 object-cover transition group-hover:scale-105" />
                  </div>
                ) : (
                  <div className="rounded-xl h-52 mb-4 flex flex-col items-center justify-center bg-wheat-50/50 border border-wheat-500/30" data-testid={`certificate-placeholder-${c.id}`}>
                    <BadgeCheck className="h-10 w-10 text-wheat-600" strokeWidth={1.25}/>
                    <p className="mt-3 text-[10px] uppercase tracking-[0.28em] text-wheat-700">Coming later</p>
                  </div>
                )}
                <p className="eyebrow">{c.issuer}</p>
                <h3 className="mt-2 font-serif text-2xl text-forest-900">{c.title}</h3>
                <p className="mt-2 text-sm text-forest-700">{comingLater ? `Expected ${c.issue_date}` : c.issue_date}</p>
                {c.notes && <p className="mt-3 text-sm text-forest-700/80 leading-relaxed">{c.notes}</p>}
              </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
